import { translate } from 'loankeeper-common/helpers'

export default (key) => translate(`frm_client_org-${key}`)
